import React             from 'react';
import { guid }          from 'rewire-common';
import { version }       from 'rewire-core';
import { IRow, IColumn } from 'rewire-grid';
import Grid              from '../ui/Grid';
import { useWatch }      from './SettingsModel';
import classNames        from 'classnames';

export default function GridLayout({classes, settings, grid, oldSelect}: any) {
  useWatch(() => (version(settings.items)), () => { // watch for the items changing and sync the rows of the grid!!
    grid.set(settings.items.map((r: any) => ({id: guid(), data: r, options: {cls: classNames({archived: r.archived})}})));
  }, true);

  useWatch(() => settings.selectedItem, () => { // watch for the items changing and sync the rows of the grid!!
    const item = settings.selectedItem;
    const row = item ? grid.rows.find((r: IRow) => r.data.id === item.id) : undefined;
    if (row) {
      const column = (grid.focusedCell?.column) || grid.columns[0];
      requestAnimationFrame(() => oldSelect.call(grid, [row.cells[column.name]]));
      return;
    }
    grid.selectRows([]);
  }, true);

  useWatch(() => (version(settings.udfs)), () => { // watch for the udfs changing and sync the columns of the grid!!
    setTimeout(() => settings.addCustomGridColumns(grid), 0);
  }, true);

  useWatch(() => (version(settings.hiddenGridColumns)), () => {
    grid.columns.forEach((col: IColumn) => {
      col.visible = !settings.hiddenGridColumns.includes(col.name);
    });
  }, true);

  return (
    <div className={classes.tableWrapper}>
      <Grid grid={grid} style={{height: '100%'}} />
    </div>
  );
}
